import React from 'react';
import { ErrorBoundary as ReactErrorBoundary } from 'react-error-boundary';

const ErrorFallback = ({ error, resetErrorBoundary, fallbackUI }) => {
  if (typeof fallbackUI === 'string') {
    return (
      <div className="p-4 border border-red-500 rounded-lg bg-red-900/30 text-white">
        <h3 className="font-bold mb-2">Error</h3>
        <p className="text-white/70 mb-4">{fallbackUI}</p>
        <button 
          onClick={resetErrorBoundary}
          className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded"
        >
          Try Again
        </button>
      </div>
    );
  }
  
  return fallbackUI;
};

const ErrorBoundary = ({ children, fallback }) => {
  return (
    <ReactErrorBoundary
      FallbackComponent={({ error, resetErrorBoundary }) => (
        <ErrorFallback 
          error={error} 
          resetErrorBoundary={resetErrorBoundary} 
          fallbackUI={fallback} 
        />
      )}
    >
      {children}
    </ReactErrorBoundary>
  );
};

export default ErrorBoundary;
